import WhiteDefaultMarker from 'common/assets/images/MarkerDefault.png';

class Marker {
  constructor({
    id, position, infoWindowContext, circleRadius, settings, styles,
  }) {
    this.id = id;
    this.position = position;
    this.infoWindowContext = infoWindowContext;
    this.circleRadius = circleRadius;
    this.settings = settings || this.settings;
    this.styles = styles;
  }
}
Marker.prototype.settings = {
  icon: {
    url: WhiteDefaultMarker,
    scaledSize: {
      height: 50,
      width: 36,
    },
  },
};


class InfoWindow {
  constructor({ component, settings }) {
    this.component = component;
    this.settings = settings || this.settings;
  }
}
InfoWindow.prototype.settings = {
  maxWidth: 400,
  customMarker: false,
};


class CircleRadius {
  constructor({ radius, center, settings }) {
    this.radius = radius;
    this.center = center;
    this.settings = settings || this.settings;
  }
}
CircleRadius.prototype.settings = {
  fillColor: '#db1b4d',
  fillOpacity: 0.2,
  strokeColor: '#db1b4d',
  strokeOpacity: 0.4,
};

export { Marker, InfoWindow, CircleRadius };
